export default __webpack_public_path__ + "img/1_1-8fa548cc.png";